import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BASE}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
    const t = localStorage.getItem('lq_token');
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            // Token might be expired — clear silently
            localStorage.removeItem('lq_token');
        }
        return Promise.reject(err);
    }
);

export const apiAudioUrl = (relPath) => (relPath?.startsWith('http') ? relPath : `${BASE}${relPath}`);
